<template>
  <section ref="section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-11 col-md-10">
          <div class="intro">
            <Observer name="fade-up">
              <div class="headline h2" v-if="item.headline" v-text="item.headline"></div>
              <h2 class="title h3" v-if="item.title" v-html="item.title"></h2>
            </Observer>
          </div>
          <div class="watch" v-if="item.images.length > 1">
            <hooper :settings="hooperSettings" ref="carousel" tabindex="-1">
              <slide v-for="(image, i) in item.images" :key="i" :index="i">
                <Observer name="fade-up">
                  <router-link :to="localizedUrl + image.link" v-if="image.link && !image.link.includes('http')">
                    <lazy-picture :item="image" desktop-ratio="1.47833333" mobile-ratio="1.47833333"></lazy-picture>
                  </router-link>
                  <a :href="image.link" v-else-if="image.link && image.link.includes('http')">
                    <lazy-picture :item="image" desktop-ratio="1.47833333" mobile-ratio="1.47833333"></lazy-picture>
                  </a>
                  <lazy-picture v-else :item="image" desktop-ratio="1.47833333" mobile-ratio="1.47833333"></lazy-picture>
                </Observer>
              </slide>
              <div class="hooper-navigation" slot="hooper-addons" v-if="item.images.length > 1">
                <button v-if="currentSlide > 0 || item.enableInfiniteScroll" type="button" class="hooper-prev" :aria-label="$t('Previous slide')"
                        @click="prevSlide()"></button>
                <button v-if="currentSlide < item.images.length - 1 || item.enableInfiniteScroll" type="button" class="hooper-next" :aria-label="$t('Next slide')"
                        @click="nextSlide()"></button>
              </div>
            </hooper>
          </div>
          <div class="watch" v-if="item.images.length === 1">
            <Observer name="fade-up">
              <lazy-picture :item="item.images[0]" desktop-ratio="1.47833333" mobile-ratio="1.47833333"></lazy-picture>
            </Observer>
          </div>
          <Observer name="fade-up">
            <div class="subtitle h2" v-if="item.subtitle" v-text="item.subtitle"></div>
            <p v-if="item.text" v-html="item.text"></p>
          </Observer>
        </div>
      </div>
    </div>
    <lazy-picture class-name="bg" :item="item" desktop-ratio="0.54479167" mobile-ratio="1.47833333"></lazy-picture>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import LazyPicture from '../utils/LazyPicture'
import {
  Hooper,
  Slide
} from 'hooper'

export default {
  props: ['item', 'pagePosition', 'siblings-components'],
  mixins: [ReadyHook],
  name: 'Defy5hzIntro',
  components: {
    LazyPicture,
    Hooper,
    Slide
  },
  data() {
    return {
      currentSlide: 0,
      itemsToShow: 0,
      hooperSettings: this.item.images.length > 1 ? {
        initialSlide: 0,
        itemsToShow: 1,
        transition: 400,
        centerMode: true,
        touchDrag: true,
        keysControl: true,
        wheelControl: false,
        infiniteScroll: this.item.enableInfiniteScroll
      } : {
        initialSlide: 0,
        itemsToShow: 1
      }
    }
  },
  methods: {
    nextSlide() {
      this.currentSlide = this.currentSlide + 1
      this.$refs.carousel.slideNext()
    },
    prevSlide() {
      this.currentSlide = this.currentSlide - 1
      this.$refs.carousel.slidePrev()
    }
  },
  computed: {
    localizedUrl () {
      return currentStoreView().url || ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  overflow: hidden;
  padding: 0 0 em(50);
  text-align: center;

  @include bp(max md) {
    padding: 0 0 4rem;
  }

  .intro {
    display: flex;
    height: 80vh;
    min-height: 80rem;
    align-items: center;
    justify-content: center;

    @include bp(max md) {
      min-height: 40rem;
    }
  }

  .watch {
    width: 40rem;
    z-index: 10;
    margin: -25% auto 5rem;
    position: relative;

    /deep/ img, /deep/ picture {
      width: 100%;
    }

    @include bp(max md) {
      width: 100%;
      margin: -60% auto 2rem;
    }
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 80vh;
    min-height: 80rem;
    pointer-events: none;

    @include bp(max md) {
      min-height: 40rem;
    }

    /deep/ img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
    }
  }

  .container {
    position: relative;
    z-index: 10;
  }
}

.headline {
  color: var(--zenith-white);
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.title {
  color: var(--zenith-white);
  margin-bottom: 3rem;
}

.subtitle {
  margin-bottom: 3rem;
  text-transform: uppercase;
}

.hooper {
  outline: none;
  height: auto;
  padding: 0;

  /deep/ .hooper-slide {
    position: relative;
    overflow: hidden;
  }

  .hooper-navigation {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    display: none;

    @include bp(xl) {
      display: block;
    }

    .hooper-prev {
      outline: none;
      &:before {
        content: "\e903";
      }
      &:hover {
        &:before {
          @include pillPrevHover();
        }
      }
    }
    .hooper-next {
      outline: none;
      &:before {
        content: "\e925";
      }
      &:hover {
        &:before {
          @include pillNextHover();
        }
      }
    }

    button {
      opacity: 1;
      padding: 1.3rem;
      border-radius: 100%;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
      background: #f8f8f8;

      svg {
        display: none;
      }

      &:before {
        display: block;
        font-family: 'zenith', sans-serif !important;
        speak: none;
        font-size: em(20);
        line-height: 2rem;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      &.is-disabled {
        opacity: 0 !important;
        pointer-events: none;
      }

      &:hover,
      &:active,
      &:focus {
        opacity: 1;
      }
    }
  }
}

@keyframes bouncing {
  0%,
  100% {
    transform: translateY(-0.3rem);
  }
  25% {
    transform: translateY(0.7rem);
  }
}
</style>
